/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import Standalone404 from 'base/components/standalone/404';

export const DynamicStandalone404 = Standalone404;
export type DynamicStandalone404Props = PropsFromComponent<typeof Standalone404>;

export const DynamicStandalone404With = (extras: DynamicStandaloneExtras): typeof Standalone404 => {
    return function DynamicStandalone404(props) {
        const theme = extras.theme.useTheme(extras.theme.key || '404');
        return <Standalone404 {...mergeProps({ options: { theme } }, props)} />;
    }
}